import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getActiveCurrencies = ({ pageNumber = 1 }) => {
  return axios.get(`/currency/active/${pageNumber}`);
};

export const useActiveCurrencies = ({ pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['activeCurrencies', pageNumber],
    queryFn: () => getActiveCurrencies({ pageNumber }),
  });
};
